import split from './split';
import toArray from './to_array';

export default (val) =>
  toArray(val)
    .map((char) => `U+${char.codePointAt(0).toString(16)}`)
    .join(', ');
